import { render, staticRenderFns } from "./BildungsgangVerrechnungspositionen.vue?vue&type=template&id=3f85b1dd&scoped=true&"
import script from "./BildungsgangVerrechnungspositionen.vue?vue&type=script&lang=js&"
export * from "./BildungsgangVerrechnungspositionen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f85b1dd",
  null
  
)

export default component.exports